import { render, staticRenderFns } from "./detailGx.vue?vue&type=template&id=2f5d3cb0&scoped=true&"
import script from "./detailGx.vue?vue&type=script&lang=js&"
export * from "./detailGx.vue?vue&type=script&lang=js&"
import style0 from "./detailGx.vue?vue&type=style&index=0&id=2f5d3cb0&scoped=true&lang=scss&"
import style1 from "./detailGx.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d3cb0",
  null
  
)

export default component.exports